var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "uxo-list" },
    [
      _vm.incidents.length
        ? _vm._l(_vm.incidents, function(incident) {
            return _c(
              "div",
              {
                staticClass:
                  "column is-4-mobile is-4-tablet is-3-desktop mb-2 mb-md-4"
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "uxo-list__item",
                    attrs: { href: _vm.incidentUrl(incident) }
                  },
                  [
                    incident.images.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "uxo-list__item-image-placeholder border-radius",
                            style: {
                              "background-image":
                                "url('" + incident.images[0].aws_url + "')"
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "image mb-1 d-hidden",
                              attrs: {
                                src: incident.images[0]
                                  ? incident.images[0].aws_url
                                  : "",
                                alt: incident.name
                              }
                            })
                          ]
                        )
                      : _c("div", {
                          staticClass:
                            "uxo-list__item-image-placeholder border-radius"
                        }),
                    _vm._v(" "),
                    _c("h5", { staticClass: "uxo-list__item-title" }, [
                      _vm._v(_vm._s(incident.name))
                    ])
                  ]
                )
              ]
            )
          })
        : [_vm._m(0)]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "empty-search column text-center py-4 py-md-10" },
      [
        _c("h1", { staticClass: "empty-search__title mb-3" }, [
          _vm._v(
            "Unfortunately, there are not any results matching your\n                criteria"
          )
        ])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d817d33a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d817d33a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/uxo/Incidents.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d817d33a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/uxo/Incidents.vue
// module chunks = 0 1